module.exports = __webpack_public_path__ + "img/hover_icon_impedimento_visual.1bb27856.svg";